import { render } from "./VentasCreate.vue?vue&type=template&id=39af9592&scoped=true"
import script from "./VentasCreate.vue?vue&type=script&lang=js"
export * from "./VentasCreate.vue?vue&type=script&lang=js"

import "./VentasCreate.vue?vue&type=style&index=0&id=39af9592&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39af9592"]])

export default __exports__